import './bootstrap';
import $ from 'jquery';
import * as bootstrap from "bootstrap";
import { tns } from "tiny-slider/src/tiny-slider"
window.tns = tns;


import './script';

